import {EventEmitter} from 'events';
import {Dispatcher, Action} from '../Dispatcher';

var CHANGE_EVENT = 'change';

export class BaseStore extends EventEmitter {
    constructor() {
        super();

        Dispatcher.subscribe(this, this.onAction);
    }

    onAction(action: Action) {
        console.warn("Internal error: onAction method must be overriden in derived classes");
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }
    
    /**
   * @param {function} callback
   */
    addChangeListener(callback: () => void) {
        this.on(CHANGE_EVENT, callback);
    }
    
    /**
  * @param {function} callback
  */
    removeChangeListener(callback: () => void) {
        this.removeListener(CHANGE_EVENT, callback);
    }
}


// WEBPACK FOOTER //
// ./Scripts/stores/BaseStore.ts